import {ConversationSortPropertiesEnum} from '../../../libs/shared/core/src/models/api/conversationCommonTypes';
import {CellsSortDirectionsEnum} from '../../../src/models/api/sortOptionModel';
import {
  InboxesFiltersEnum,
  TeammatesMessageFoldersEnum,
} from '../../../src/models/url/models/inboxesUrlModel';
import {
  InboxesConversationsParameters,
  InboxesParametersTypesEnum,
  InboxesSearchParameters,
  InboxesUserParameters,
} from '../../../src/store/panels/inboxes/parameters/inboxesParameters';
import {
  clearInboxesParametersSelection,
  emptyInboxesSelection,
  messageFolderToConversationFolder,
  setInboxesParametersSelection,
} from '../../../src/store/panels/inboxes/parameters/inboxesParametersHelpers';

/*
 * Helpers.
 */

export function createBaseUserParameters(
  userId: number,
  messageFolder: TeammatesMessageFoldersEnum,
  sortProperty: ConversationSortPropertiesEnum = ConversationSortPropertiesEnum.LAST_ACTIVITY_DATE,
  sortDirection: CellsSortDirectionsEnum = CellsSortDirectionsEnum.DESCENDING,
): InboxesUserParameters {
  return {
    type: InboxesParametersTypesEnum.USER,
    teammateId: userId,
    folder: messageFolderToConversationFolder(messageFolder),
    filters: [InboxesFiltersEnum.OPEN],
    sortDirection,
    sortProperty,
    selection: emptyInboxesSelection,
    refinement: undefined,
  };
}

export function updateParametersWithSearch(
  parameters: InboxesConversationsParameters,
  search: InboxesSearchParameters | undefined,
): InboxesConversationsParameters {
  // Search => Normal.
  if (!search) {
    return {
      ...setInboxesParametersSelection(parameters, {
        selection: parameters.search?.fromSelection || emptyInboxesSelection,
      }),
      search: undefined,
    };
  }

  // Normal => Search & Search => Search.
  return {
    ...clearInboxesParametersSelection(parameters),
    search: {
      ...search,
      fromSelection: search.fromSelection || parameters.selection,
    },
  };
}
